import { useState, useCallback } from 'react';

export const useSectionManagement = () => {
  const [selectedSection, setSelectedSection] = useState<string>();
  const [sectionNames, setSectionNames] = useState<Record<string, string>>({});
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});

  const editSection = useCallback((sectionId: string, name: string) => {
    if (selectedSection !== sectionId) {
      setSelectedSection(sectionId);
      setSectionNames((prev) => ({ ...prev, [sectionId]: name }));
    }
  }, [selectedSection]);

  const handleNameChange = useCallback((sectionId: string, name: string) => {
    setSectionNames((prev) => ({ ...prev, [sectionId]: name }));
  }, []);

  const toggleSection = useCallback((sectionId: string) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  }, []);

  const clearSelectedSection = useCallback(() => {
    setSelectedSection(undefined);
  }, []);

  const clearSectionNames = useCallback(() => {
    setSectionNames({});
  }, []);

  return {
    selectedSection,
    sectionNames,
    expandedSections,
    editSection,
    handleNameChange,
    toggleSection,
    clearSelectedSection,
    clearSectionNames,
    setSelectedSection
  };
}; 